module.exports = __webpack_public_path__ + "media/images/pic/home/1-ed03b1267de77cc7aaf996252171a123.svg";